import { render, staticRenderFns } from "./terminalList.vue?vue&type=template&id=3afcfc80"
import script from "./terminalList.vue?vue&type=script&lang=js"
export * from "./terminalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afcfc80')) {
      api.createRecord('3afcfc80', component.options)
    } else {
      api.reload('3afcfc80', component.options)
    }
    module.hot.accept("./terminalList.vue?vue&type=template&id=3afcfc80", function () {
      api.rerender('3afcfc80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/level-adjustment-management/form/components/terminalList.vue"
export default component.exports